import React, {createContext, useContext, useState, useCallback} from "react";
import {ApplicationContextType, ValidationMessage} from "../types/ApplicationContextType";

const ApplicationContext = createContext<ApplicationContextType | undefined>(undefined);

export const ApplicationContextProvider: React.FC<{children?: React.ReactNode}> =
    ({children}) => {
        const [validationMessage, setValidationMessageState] = useState<ValidationMessage | null>(null);
        
        const setValidationMessage = useCallback((value: React.SetStateAction<ValidationMessage | null>) => {
            setValidationMessageState(value);
        }, []);

        return (
            <ApplicationContext.Provider value={{validationMessage, setValidationMessage}}>
                {children}
            </ApplicationContext.Provider>
        );
    }

export const useApplicationContext = () => {
    const applicationContext = useContext(ApplicationContext);
    if (!applicationContext) {
        throw new Error('useApplicationContext must be used within a ApplicationContextProvider');
    }
    return applicationContext;
};



